export default __webpack_public_path__ + "static/media/promotion.7b1e489c.svg";